<template>
  <div class="index" >


    <el-image aria-hidden="true" class="bgs" src="/static/image/problem5/BG1.png"></el-image>
    <div class="bg">
      <p tabindex="1" id="title-p" role="text" aria-label="第五题，当对方和你意见不同无法达成一致时，你该怎么办？" >
        <el-image class="title"
                  src="/static/image/problem5/题目.png"></el-image>
      </p>
      <div :aria-hidden="getfocus">
        <div class="options">

          <div>
            <img @click="problema_btn()" :aria-checked="problema_checked" role="radio" aria-label="A，有点生气，争论到底"
                 class="options_a" :src="problema_src"></img>
          </div>

          <div>
            <img @click="problemb_btn()" :aria-checked="problemb_checked" role="radio" aria-label="B，耐心解释，直到放弃"
                 class="options_b" :src="problemb_src"></img>
          </div>

          <div>
            <img @click="problemc_btn()" :aria-checked="problemc_checked" role="radio" aria-label="C，大道朝天，各走一边"
                 class="options_c" :src="problemc_src"></img>
          </div>

        </div>

        <div>
          <el-image role="text" aria-label="无障碍贴士，认知障碍的小伙伴就像是无法和对方达成一致的你，对他们不要着急，多点包容吧~" class="tips"
                    src="/static/image/problem5/小贴士.png"></el-image>
        </div>


        <div class="btns">
          <div class="btn">
            <el-button aria-label="上一题" @click="previous()"></el-button>
          </div>
          <div class="btn1">
            <el-button aria-label="查看结果" @click="onSubmit()"></el-button>
          </div>
        </div>

      </div>
    </div>


    <!--    <div>-->
    <!--      <span class="tttt">你在意每天的穿搭吗？</span>-->
    <!--    </div>-->


  </div>
</template>

<script>

import utils from "../utils/util"

export default {
  name: 'problem5',
  data() {
    return {
      story:0,// 选择无障碍故事
      getfocus: true,
      problema_checked: false,
      problemb_checked: false,
      problemc_checked: false,
      problema_src: "/static/image/problem5/选项A.png",
      problemb_src: "/static/image/problem5/选项B.png",
      problemc_src: "/static/image/problem5/选项C.png",
    }
  },
  mounted() {
    this.title_h4 = this.$route.params.setid
    this.$nextTick(function () {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        setTimeout((() => {
          this.getfocus = false
        }), 600);
      } else {
        this.getfocus = false
      }
      document.getElementById('title-p').focus()
      // 适配UI
      utils.adaptUI()



    })
  },
  methods: {

    // 选项A
    problema_btn() {
      this.problema_checked = true
      this.problema_src = "/static/image/problem5/选项A-选中效果.png"
      this.problemb_checked = false
      this.problemc_checked = false
      this.problemb_src = "/static/image/problem5/选项B.png"
      this.problemc_src = "/static/image/problem5/选项C.png"
      //获取随机数
      let t = new Date().getTime()
      const t1 = t+""
      const t2 = t1.charAt(t1.length-1)
      t = parseInt(t2)
      if (t<3){
        this.story = 0
      }else if(t>=3 && t<6){
        this.story = 1
      }else{
        this.story = 2
      }
    },
    // 选项B
    problemb_btn() {
      this.problemb_checked = true
      this.problemb_src = "/static/image/problem5/选项B-选中效果.png"
      this.problema_checked = false
      this.problemc_checked = false
      this.problema_src = "/static/image/problem5/选项A.png"
      this.problemc_src = "/static/image/problem5/选项C.png"
      //获取随机数
      let t = new Date().getTime()
      const t1 = t+""
      const t2 = t1.charAt(t1.length-1)
      t = parseInt(t2)
      if (t<3){
        this.story = 3
      }else if(t>=3 && t<6){
        this.story = 4
      }else{
        this.story = 5
      }
    },
    // 选项C
    problemc_btn() {
      this.problemc_checked = true
      this.problemc_src = "/static/image/problem5/选项C-选中效果.png"
      this.problema_checked = false
      this.problemb_checked = false
      this.problema_src = "/static/image/problem5/选项A.png"
      this.problemb_src = "/static/image/problem5/选项B.png"
      //获取随机数
      let t = new Date().getTime()
      const t1 = t+""
      const t2 = t1.charAt(t1.length-1)
      t = parseInt(t2)
      if (t<3){
        this.story = 6
      }else if(t>=3 && t<6){
        this.story = 7
      }else{
        this.story = 8
      }
    },


    // 下一题
    onSubmit() {
      if (this.problema_checked === false && this.problemb_checked === false && this.problemc_checked === false) {
        this.$message({
          message: '选择选项后再继续哦~',
          type: 'warning',
          center: true,
          duration:2000,
        });
      } else {
        localStorage.setItem("story", this.story)
        this.$router.replace('/load_results')
      }
    },
    // 上一题
    previous() {
      this.$router.replace('/problem4')
    },



  }
}
</script>

<style scoped>


.title {
  left: 25%;
  width: 100%;
  margin-top: 20%;
}

.options_a {
  margin-left: 15%;
  width: 70%;
}

.options_b {
  margin-left: 15%;
  width: 70%;
  margin-top: 5%;
}

.options_c {
  margin-left: 15%;
  width: 70%;
  margin-top: 5%;
}

.tips {
  left: 15%;
  width: 70%;
  margin-top:5%;
  /*pointer-events: none;*/
}


.index {
  height: 100vh;
  background-image: url("/static/image/problem5/BG.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}



.btn {
  float: left;
  margin-left: 12%;
  margin-top: 5%;
}

.btn1 {
  float: right;
  margin-right: 12%;
  margin-top: 5%;
}

.btns {
  text-align: center;
}
.btn > .el-button {
  width: 110px;
  height: 40px;
  background: url("/static/image/problem2/上一题.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  border: none;
}

.btn1 > .el-button {
  width: 110px;
  height: 40px;
  background: url("/static/image/problem5/查看结果.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  border: none;
}



.bg {
  position: absolute;
  z-index: 1;
  top: 1px;
  left:0;
  right:0;
}

.bgs {
  left: 5%;
  margin-top: 1.5%;
  width: 90%;
  height: 97%;

}


/*去掉获得焦点的边框*/
p {
  outline: none;
}


</style>





// WEBPACK FOOTER //
// src/components/home/problem5.vue